var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_1746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.536 11.019L16.794 13.5L14.514 14.517L13.5 16.794L11.019 16.536L9 18L6.981 16.536L4.5 16.794L3.48296 14.514L1.206 13.5L1.464 11.019L0 9L1.464 6.981L1.206 4.5L3.486 3.48296L4.5 1.206L6.981 1.464L9 0L11.019 1.464L13.5 1.206L14.517 3.486L16.794 4.5L16.536 6.981L18 9L16.536 11.019Z",
    fill: "#00EC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1403 6.66007L12.2914 5.81104L7.20036 10.902L5.50232 9.20696L4.65332 10.053L7.20036 12.6L13.1403 6.66007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_1746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.33123e2203deb2be91843e37efb09d22.svg";
export { ForwardRef as ReactComponent };